import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  authPatch,
  CORE_API_ENTRYPOINT,
  getCoreDomain,
} from '@probatix/common/services/services.helpers'
import { getCurrentLocale } from '@probatix/common/translations'
import { setJWT } from '../patients'

// Define a service using a base URL and expected endpoints
export const partnersApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    getPartnerDownloadResult: builder.query<any, any>({
      query: ({ uuid }) => ({
        headers: authPatch(),
        method: 'GET',
        url:
          `${process.env.VITE_CORE_API_ENTRYPOINT}/api/v0/test_results/${uuid}/pdf`,
      }),
    }),
    postPartnersActivation: builder.mutation<any, any>({
      query: ({ activationToken, orderId }) => ({
        body: {
          activationToken,
          orderId,
        },
        headers: {
          Accept: 'application/json',
          'Accept-Language': getCurrentLocale().code.slice(0, 2),
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/patients/partner/activate`,
      }),
      transformResponse: (responseData: any) => setJWT(responseData),
    }),
    postPartnersSignUp: builder.mutation<any, any>({
      query: ({ orderId, password, redirectUrl, username }) => ({
        body: {
          orderId,
          password,
          redirectUrl,
          username,
        },
        headers: {
          Accept: 'application/json',
          'Accept-Language': getCurrentLocale().code.slice(0, 2),
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/patients/partner/sign_up`,
      }),
    }),
  }),
  reducerPath: 'partnersApi',
})

export const usePostPartnersSignUp = partnersApi.endpoints.postPartnersSignUp.useMutation
export const usePostAccountActivation = partnersApi.endpoints.postPartnersActivation.useMutation
export const useGetPartnersDownloadResult = partnersApi.endpoints.getPartnerDownloadResult.useLazyQuery

